import MilestonesSerializer from './base';

export default class Progression extends MilestonesSerializer {}
